import { createUniqueListenersOverTimeChart } from "./over_time_chart";
import { wireUniqueListenersPicker } from "../../date_pickers/unique_listeners_over_time_datepicker";
import { downloadChartCsv } from "../../shared/csv_download";
import "./episode_breakdown_table";

document.addEventListener('alpine:init', () => {
  Alpine.data('ShowListenersOverTime', () => ({
    chartApi: null,
    pickerApi: null,
    loading: false,
    lastParams: { chart_type: 'listeners_over_time', date_range: '7d' },
    init() {
      const el = this.$el ? this.$el.querySelector('#UniqueListenersOverTimeChart') : document.getElementById('UniqueListenersOverTimeChart');
      if (!el) return;
      const apiUrl = (el && el.dataset && el.dataset.apiUrl) ? el.dataset.apiUrl : '/analytics/chart';

      this.chartApi = createUniqueListenersOverTimeChart(el, apiUrl);

      const onChange = async (payload) => {
        this.loading = true;
        try {
          if (payload?.type === 'preset') {
            await this.chartApi.loadPreset(payload.days);
            this.lastParams = { chart_type: 'listeners_over_time', date_range: `${payload.days}d` };
          } else if (payload?.type === 'custom') {
            await this.chartApi.loadCustom(payload.from, payload.to);
            this.lastParams = { chart_type: 'listeners_over_time', date_range: 'custom', start_date: payload.from, end_date: payload.to };
          } else if (payload?.type === 'all_time') {
            // Treat all-time like a large custom date (service interprets in controller if needed)
            await this.chartApi.loadPreset(3650); // fallback large window
            this.lastParams = { chart_type: 'listeners_over_time', date_range: 'all_time' };
          }
        } catch (e) {
          console.error('unique listeners: change handler error', e);
        } finally {
          this.loading = false;
        }
      };
      this.pickerApi = wireUniqueListenersPicker(this.$el || document, onChange);

      this.loading = true;
      this.chartApi
        .loadPreset(7)
        .catch(e => console.error('unique listeners: initial load error', e))
        .finally(() => { this.loading = false; });

      try { this.pickerApi && this.pickerApi.setActive && this.pickerApi.setActive(7); } catch (_) {}

      // CSV download button
      const dlBtn = (this.$el || document).querySelector('#prefix-unique-csv');
      if (dlBtn) {
        dlBtn.addEventListener('click', async () => {
          try {
            const params = new URLSearchParams();
            Object.entries(this.lastParams || {}).forEach(([k, v]) => params.append(k, v));
            await downloadChartCsv({
              endpoint: apiUrl,
              params,
              filename: 'listeners_over_time.csv',
              columns: [
                { key: 'created_at_date', label: 'Date' },
                { key: 'unique_listeners', label: 'Unique Listeners' }
              ],
              dataPath: 'download_data'
            });
          } catch (e) { console.error('unique csv download error', e); }
        });
      }

      window.addEventListener('turbo:before-cache', () => this.destroy());

      // Clear button wiring for Show Unique Listeners Over Time
      try {
        const input = (this.$el || document).querySelector('#listener-range');
        const clearBtn = (this.$el || document).querySelector('#unique-listeners-clear');
        const fromEl = (this.$el || document).querySelector('#unique_listeners_from');
        const toEl = (this.$el || document).querySelector('#unique_listeners_to');

        const syncClearVisibility = () => {
          try {
            if (!clearBtn || !input) return;
            const show = Boolean(input.value && input.value.trim().length > 0);
            if (show) { clearBtn.classList.remove('hidden'); } else { clearBtn.classList.add('hidden'); }
          } catch (_) {}
        };
        const handleClear = () => {
          try {
            if (input) input.value = '';
            if (fromEl) fromEl.value = '';
            if (toEl) toEl.value = '';
            // Restore default view to 7 days via the picker API
            try { this.pickerApi && this.pickerApi.setPreset && this.pickerApi.setPreset(7); } catch (_) {}
            syncClearVisibility();
          } catch (_) {}
        };
        if (input) {
          input.addEventListener('input', syncClearVisibility);
          input.addEventListener('change', syncClearVisibility);
          setTimeout(syncClearVisibility, 0);
        }
        if (clearBtn) clearBtn.addEventListener('click', handleClear);
      } catch (_) {}
    },

    destroy() {
      try { this.chartApi && this.chartApi.destroy && this.chartApi.destroy(); } catch (_) {}
      try { this.pickerApi && this.pickerApi.destroy && this.pickerApi.destroy(); } catch (_) {}
      this.chartApi = null;
      this.pickerApi = null;
    }
  }));
});
